module.exports = __webpack_public_path__ + "img/opieńka miodowa plain.cd50feaa.svg";